/** Tenant hierarchy /metering/tenant/level (tenantLevel/index.vue + TierDialog.vue) */
export default {
  tenantLevelPage: {
    emptyNoPermission: 'No permission to view',
    pageTitle: 'Hierarchy',
    tipTitle: 'How to use',
    tipLine1: '• Left tree: organization tiers',
    tipLine2: '• Right-click: add child, edit, delete',
    tipLine3: '• Drag and drop: reorder structure',
    tipLine4: '• Bind: assign tenants to a tier',
    tipText: 'Right-click a node for tier actions; drag to reorder.',
    panelTierStructure: 'Tier structure',
    phSearchTier: 'Search tiers',
    btnAddTier: 'New tier',
    panelOperation: 'Actions',
    btnBindTenants: 'Bind tenants',
    btnUnbindTenants: 'Unbind tenants',
    btnConfirmOp: 'Confirm',
    btnSubmitting: 'Working…',
    btnCancel: 'Cancel',
    hintBind: 'Select a tier and tenants to bind',
    hintUnbind: 'Select tenants to unbind',
    panelUnboundTenants: 'Unassigned tenants',
    phSearchTenant: 'Search tenants',
    btnRefresh: 'Refresh',
    menuAddChild: 'Add child tier',
    menuEdit: 'Edit tier',
    menuDelete: 'Delete tier',
    msgNoAddPerm: 'No permission to add',
    msgNoBindPerm: 'No permission to bind/unbind',
    msgLoadTierFail: 'Failed to load tiers',
    msgLoadTierErr: 'Failed to load tier tree',
    msgLoadUnboundFail: 'Failed to load unassigned tenants',
    msgLoadUnboundErr: 'Failed to load tenant list',
    msgSelectBoundTier: 'Select a tier that has tenants',
    confirmReorder: 'Apply this structure change?',
    titleTip: 'Notice',
    btnOk: 'OK',
    msgReorderOk: 'Structure updated',
    msgReorderFail: 'Could not update structure',
    msgReorderErr: 'Update failed',
    msgSelectTierToBind: 'Select a tier to bind to',
    msgSelectTenantToBind: 'Select at least one tenant',
    confirmBindTitle: 'Confirm bind',
    confirmBindBody: 'Bind {count} tenant(s) to the selected tier?',
    confirmUnbindTitle: 'Confirm unbind',
    confirmUnbindBody: 'Unbind {count} tenant(s)?',
    msgBindOk: 'Tenants bound',
    msgBindFail: 'Bind failed',
    msgBindErr: 'Bind request failed',
    msgUnbindOk: 'Tenants unbound',
    msgUnbindFail: 'Unbind failed',
    msgUnbindErr: 'Unbind request failed',
    msgSelectParentFirst: 'Select a parent tier first',
    msgSelectEditTier: 'Select a tier to edit',
    msgSelectDeleteTier: 'Select a tier to delete',
    confirmDeleteTier: 'Delete this tier? This cannot be undone.',
    titleWarn: 'Warning',
    msgDeleteOk: 'Deleted',
    msgDeleteFail: 'Delete failed',
    msgDeleteErr: 'Delete request failed',
    msgCannotDropOnBoundTier: 'This tier has tenants bound, cannot be used as a parent'
  },
  tierDialogPage: {
    dialogTitleAdd: 'New tier',
    dialogTitleEdit: 'Edit tier',
    dialogTitleAddChild: 'New child tier',
    formParentTier: 'Parent tier',
    phParentTier: 'Parent tier',
    formTierName: 'Tier name',
    phTierName: 'Enter tier name',
    btnCancel: 'Cancel',
    btnAdd: 'Create',
    btnModify: 'Save',
    ruleNameRequired: 'Please enter a tier name',
    ruleNameLen: 'Length must be between 1 and 50 characters',
    msgAddOk: 'Tier created',
    msgAddFail: 'Could not create tier',
    msgAddErr: 'Create failed',
    msgUpdateOk: 'Tier updated',
    msgUpdateFail: 'Could not update tier',
    msgUpdateErr: 'Update failed'
  }
}
